import abstractGetSyncPromise, {
    type GetSyncPromise,
    type GetSyncPromiseOptions,
} from '@gaia/utils/abstractGetSyncPromise';
import debounce from 'lodash/debounce';
import {useMemo} from 'react';

import useForceUpdate from './useForceUpdate';

export type {GetSyncPromise, SyncPromise} from '@gaia/utils/abstractGetSyncPromise';

export default function useGetSyncPromise(options?: GetSyncPromiseOptions): GetSyncPromise {
    const forceUpdate = useForceUpdate();
    return useMemo(() => {
        const debouncedForceUpdate = debounce(forceUpdate);
        return abstractGetSyncPromise({
            onPromiseReject: debouncedForceUpdate,
            onPromiseResolve: debouncedForceUpdate,
            ...options,
        });
    }, [forceUpdate, options]);
}
